import { Component } from '@angular/core';

@Component({
  selector: 'app-te-role-func',
  templateUrl: './te-role-func.component.html',
  styleUrls: ['./te-role-func.component.css']
})
export class TeRoleFuncComponent {

}
